import { CompareResult } from './compare-result';
import { SortOrder } from './sort-order';

export function sortBy<T>(key: keyof T, direction: SortOrder = 'ascending'): (a: T, b: T) => CompareResult {
    return (a: T, b: T): CompareResult => {
        const firstVal = convertToLowerCaseIfString(a[key]);
        const secondVal = convertToLowerCaseIfString(b[key]);

        const compareResult = firstVal > secondVal ? 1 : secondVal > firstVal ? -1 : 0;
        const factor = direction === 'ascending' ? 1 : -1;

        return (compareResult * factor) as CompareResult;
    };
}

function convertToLowerCaseIfString<T>(value: T[keyof T]): T[keyof T] {
    if (typeof value === 'string') {
        return value.toLowerCase() as unknown as T[keyof T];
    }
    return value;
}

export function compareByName<T extends { name: string }>(a: T, b: T): number {
    return a.name.localeCompare(b.name);
}
